import React, { Component, Fragment } from 'react';
import { Grid, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { getFormValues, change } from 'redux-form';

import { ReportGeneration } from 'Common/ObjectHelper';
import { errorToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers/';
import PointOfSaleModeForm from './components/PointOfSaleModeForm';
import FreeAndReducedModeForm from './components/FreeAndReducedModeForm';
import { LetterHistoryReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import {
  getReport,
  clearReport,
  clearErrors,
  getLetterTemplates,
} from './state/letterhistoryreport/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { TitledCard } from 'Components/';
import { FormTypes } from './constants';
import {
  LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME,
  LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME,
} from 'Common/FormEnum';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

class LetterHistoryReportContainer extends Component {
  state = {
    selectedformType: FormTypes[0],
  };

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: this.state.selectedformType.name,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getLetterTemplates();
  }

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;
    if (report && prevState !== report) {
      ReportGeneration(report, 'Letter History Report');
      this.props.clearReport();
    }
    if (errorToast(this.props, prevProps, 'error')) {
      this.props.clearErrors();
    }
  }

  handleSubmit = formValues => {
    this.props.getReport({
      ...formValues,
      [Fields.FormMode]: this.state.selectedformType.value,
    });
  };

  changeFormValue = (field, value) => {
    this.props.change(
      LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME,
      field,
      value
    );
  };

  getForm() {
    const { formValues } = this.props;
    switch (this.state.selectedformType.name) {
      case LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME:
        return (
          <PointOfSaleModeForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.SiteId]: null,
              [Fields.LetterTemplateIds]: [],
              [Fields.Statuses]: [
                StatusEnum.Free,
                StatusEnum.Reduced,
                StatusEnum.Paid,
              ],
              [Fields.StudentIdSeeds]: [],
              [Fields.FromDate]: defaultDateFormat(moment()),
              [Fields.ToDate]: defaultDateFormat(moment()),
            }}
            letterTemplates={this.props.letterTemplates}
            selectedStatuses={formValues && formValues[Fields.Statuses]}
            fromDate={formValues && formValues[Fields.FromDate]}
            toDate={formValues && formValues[Fields.ToDate]}
            selectedLetters={formValues && formValues[Fields.LetterTemplateIds]}
          />
        );
      case LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME:
        return (
          <FreeAndReducedModeForm
            onSubmit={this.handleSubmit}
            changeFormValue={this.changeFormValue}
            selectedLetterTemplates={this.props.formValues.LetterTemplateIds}
            initialValues={{
              [Fields.FromDate]: defaultDateFormat(moment()),
              [Fields.ToDate]: defaultDateFormat(moment()),
              [Fields.LetterTypes]: [],
              [Fields.SortBy]: 'family-number',
            }}
          />
        );
      default:
        return <div>Error selecting form.</div>;
    }
  }

  render() {
    const { selectedformType } = this.state;
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Letter History Report'} />
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <div className="field">
                  <label
                    className="text-orange"
                    style={{ paddingLeft: '10px' }}
                  >
                    Report Mode
                  </label>
                </div>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Button.Group
                  basic
                  className={
                    'btn-group--active-group transaction-history--btn-group'
                  }
                >
                  {FormTypes.map(formType => (
                    <Button
                      key={formType.name}
                      basic
                      className="white"
                      active={selectedformType.name === formType.name}
                      onClick={() =>
                        this.setState({
                          selectedformType: formType,
                        })
                      }
                    >
                      {formType.text}
                    </Button>
                  ))}
                </Button.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <TitledCard title="Report Settings">{this.getForm()}</TitledCard>
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    letterTemplates:
      state.LetterHistoryReportState.letterhistoryreport.letterTemplates,
    report: state.LetterHistoryReportState.letterhistoryreport.report,
    loading: state.LetterHistoryReportState.letterhistoryreport.loading,
    error: state.LetterHistoryReportState.letterhistoryreport.error,
    formValues: getFormValues(
      LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME
    )(state),
  };
};

export const LetterHistoryReport = withRouter(
  connect(mapStateToProps, {
    getReport,
    clearReport,
    clearErrors,
    change,
    getLetterTemplates,
  })(LetterHistoryReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/letterhistoryreport/LetterHistoryReport.js